module.exports = __webpack_public_path__ + "img/member_rewards_bg.bb103d42.png";